import { z } from "zod";

export const ChecklistListaSchema = z.object({
  idChecklist: z.number().optional(),
  nome: z.string(),
  descricao: z.string().optional().nullable(),
  statusCheckList: z.boolean().default(true),
});

export type ChecklistListaForm = z.infer<typeof ChecklistListaSchema>;
